<div class="flex-wrapper">
  <div class="single-chart">
    <h4 class="title title--run">Run</h4>
    <svg viewBox="0 0 36 36" class="circular-chart run">
      <path
        class="circle-bg"
        d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <path
        class="circle"
        attr.stroke-dasharray="100"
        d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <text x="18" y="15.35" class="percentage">
        {{ machineRunningRatio }}
      </text>
      <text x="18" y="25.35" class="percentage">min</text>
    </svg>
  </div>

  <div class="single-chart">
    <h4 class="title title--red">Emergency</h4>
    <svg viewBox="0 0 36 36" class="circular-chart red">
      <path
        class="circle-bg"
        d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <path
        class="circle"
        attr.stroke-dasharray="100"
        d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <text x="18" y="15.35" class="percentage">
        {{ machineErrorRatio }}
      </text>
      <text x="18" y="25.35" class="percentage">min</text>
    </svg>
  </div>

  <div class="single-chart">
    <h4 class="title title--grey">Wait</h4>
    <svg viewBox="0 0 36 36" class="circular-chart grey">
      <path
        class="circle-bg"
        d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <path
        class="circle"
        attr.stroke-dasharray="100"
        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155
      0 0 1 0 -31.831"
      />
      <text x="18" y="15.35" class="percentage">
        {{ machineWaitRatio }}
      </text>
      <text x="18" y="25.35" class="percentage">min</text>
    </svg>
  </div>

  <div class="single-chart" *ngIf="machineOverallConsumption !== undefined">
    <h4
      class="title title--energy"
      matTooltip="Energy consumption value computed on a statistical basis"
      *ngIf="machinePowerAlgorithm === 'STATISTICAL_METHOD'"
    >
      Consume 🔋
    </h4>
    <h4
      class="title title--energy"
      matTooltip="Energy computed consumption value through real data"
      *ngIf="machinePowerAlgorithm === 'POLLING_DETECTION'"
    >
      Consume 🔋
    </h4>
    <svg viewBox="0 0 36 36" class="circular-chart energy">
      <path
        class="circle-bg"
        d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <path
        class="circle"
        attr.stroke-dasharray="100"
        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155
      0 0 1 0 -31.831"
      />
      <text x="18" y="15.35" class="percentage">
        {{ machineOverallConsumption| number:'1.2-2' }}
      </text>
      <text x="18" y="25.35" class="percentage">kWh</text>
    </svg>
  </div>
</div>
